import React, { useState, useEffect } from 'react';
import { Container, Card, CardBody, Alert, Spinner } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { API_ENDPOINTS } from '../config/api';
import PageTitle from '../components/PageTitle';

const AttendanceRedirectPage = () => {
  const navigate = useNavigate();
  const { maskedCode } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    recordAttendance();
  }, [maskedCode]);

  const recordAttendance = async () => {
    try {
      setLoading(true);
      setError('');

      // Get session data using masked attendance code
      const sessionResponse = await axios.get(`${API_ENDPOINTS.CONFERENCE_SESSIONS}/masked-attendance/${maskedCode}/public`);
      const session = sessionResponse.data.session;
      const sessionId = session.id;

      // Record attendance
      const response = await axios.post(`${API_ENDPOINTS.CONFERENCE_ATTENDANCE}/record`, {
        sessionId: sessionId,
        attendanceCode: session.attendanceCode
      }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });

      setSuccess('Attendance recorded successfully!');

    } catch (error) {
      console.error('Error recording attendance:', error);
      setError(error.response?.data?.error || 'Failed to record attendance. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <PageTitle title="Attendance Redirect" description="Processing your attendance record" />
      <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
        <Container>
          <div className="text-center">
            {loading ? (
            <Card className="shadow-lg border-0" style={{ borderRadius: '16px' }}>
              <CardBody className="p-5">
                <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-4" 
                     style={{ width: '80px', height: '80px', backgroundColor: 'var(--bs-primary)'}}>
                  <Spinner animation="border" variant="light" style={{ width: '2rem', height: '2rem' }} />
                </div>
                <h4 className="text-primary mb-3">Processing Attendance</h4>
                <p className="text-muted mb-0">Recording your attendance...</p>
              </CardBody>
            </Card>
          ) : success ? (
            <Card className="shadow-lg border-0" style={{ borderRadius: '16px' }}>
              <CardBody className="p-5">
                <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-4" 
                     style={{ width: '80px', height: '80px', backgroundColor: 'var(--bs-green)'}}>
                  <i className="bi bi-check-circle text-white" style={{ fontSize: '2rem' }}></i>
                </div>
                <h4 className="text-success mb-3">Success!</h4>
                <p className="text-muted mb-4">{success}</p>
                <p className="text-muted mb-4">You can now close this tab.</p>
              </CardBody>
            </Card>
          ) : (
            <Card className="shadow-lg border-0" style={{ borderRadius: '16px' }}>
              <CardBody className="p-5">
                <div className="d-inline-flex align-items-center justify-content-center bg-danger bg-gradient rounded-circle mb-4" 
                     style={{ width: '80px', height: '80px' }}>
                  <i className="bi bi-exclamation-triangle text-white" style={{ fontSize: '2rem' }}></i>
                </div>
                <h4 className="text-danger mb-3">Error</h4>
                <p className="text-muted mb-4">{error}</p>
              </CardBody>
            </Card>
          )}
        </div>
      </Container>
      </div>
    </div>
  );
};

export default AttendanceRedirectPage; 